import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import pdfImage from "../../assests/images/pdf.png";
import { getFileNameByPath, isEmptyDash,trimString } from "../../constant";
import FileViewerModal from "../common/viewModal.js";
import { onboardingServices } from "../../services/onboardingServices";
import _ from "lodash";
import Tooltip from '@mui/material/Tooltip';

function getAnsFromOptId(response, options) {
  let filterData = options.filter((ele) => ele?._id == response?.optionId);
  return filterData[0];
}

function getAnsFromOptIds(response, options) {
  // let filterData = options.filter((ele) => ele?._id == response?.optionId);
  // let response = {optionIds:["66157c261dfaf11a676ad359","66157c261dfaf11a676ad35b"]};
  let str = ``;
  let arr = [];
  // console.log(response, options);  
  for (let i = 0; i < options?.length; i++) {
    if (_.isArray(response?.optionIds)) {
      for (let j = 0; j < response?.optionIds.length; j++) {
        if (options[i]?._id == response?.optionIds[j]) {
          arr.push(options[i]);
        }
      }
    }    
  }
  for (let k = 0; k < arr.length; k++) {    
    str += `${options[k]?.optionName}`;
    if (arr.length-1 > k) {
      str += ", ";
    }
  }
  // console.log(str);  
  return str;
}

function getObjectAns(str) {
  if (isEmptyDash(str)) {
    return "";
  } else {
    let arr = str.split("->");
    let str1 = `${arr[0]} | ${arr[1]}`;
    return str1;
  }
  //    return isEmptyDash(str) ? ["", ""] : str.split("->")
}

function GetDetailsAns(props) {
  let navigate = useNavigate();
  const [fileSrc, setFileSrc] = useState();
  const [fileExtension, setFileExtension] = useState("");
  const [fileName, setFileName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onNavigateChange = (url) => {
    navigate(url);
  };
  function getFileExtension(filename) {
    return filename.split(".").pop();
  }
  const openModal = (src) => {
    setFileSrc(src);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setFileSrc();
    setIsModalOpen(false);
  };
  const viewMMedia = (data, fileNameParam) => {
    // openModal()
    onboardingServices.viewUrlData(data, fileNameParam).then(function (response) {

      setFileSrc(response?.data?.data?.url);
      const url = response?.data?.data?.url;
      const filename1 = url?.substring(url.lastIndexOf("/") + 1);
      const filename = filename1?.split("?")[0];
      const extension = getFileExtension(filename);
      setFileExtension(extension);
      setFileName(fileNameParam);

      if (
        extension &&
        (extension == "png" ||
          extension == "jpg" ||
          extension == "jpeg" ||
          extension == "xlsx" ||
          extension == "xls" ||
          extension == "csv" ||
          extension == "docx" ||
          extension == "doc" ||
          extension == "pdf")
      ) {
        setIsModalOpen(true);
      } else {
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileNameParam;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(error => console.error('Error downloading Doc:', error));
      }
      // if (
      //   extension &&
      //   extension !== "png" &&
      //   extension !== "jpg" &&
      //   extension !== "jpeg"
      // ) {
      //   setIsModalOpen(false);
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.target = "_blank";
      //   link.rel = 'noopener noreferrer'
      //   document.body.appendChild(link);
      //   link.click();
      // } else {
      //   setIsModalOpen(true);
      // }
    });
  };

  const displayStyle = () => {
    return {
      display: 'inline-block'
    };
  };
  function formatFileName(fileName, maxLength = 25) {
    if (!fileName || typeof fileName !== 'string') {
      return '';
    }
    if (fileName.length <= maxLength) {
      return fileName;
    }

    const startLength = Math.ceil(maxLength / 2);
    const endLength = Math.floor(maxLength / 2) - 3;

    const startText = fileName.substring(0, startLength);
    const endText = fileName.substring(fileName.length - endLength);

    return `${startText}...${endText}`;
  }
  const shouldDisplayChildDetailsGap = (ele, decideChild, getAnsFromOptId, isEmptyDash) => {
    return (
      (ele?.type === "String" && decideChild?.response?.optionId === ele?.refOptionId && ele?.response?.childAnswer) ||
      (ele?.type === "String" && (ele?.name === "Monthly" || ele?.name === "Yearly")) ||
      (ele?.type === "Object") ||
      (decideChild?.response?.optionId === ele?.refOptionId &&
        ele?.type === "Dropdown" && decideChild && getAnsFromOptId(ele?.response, ele?.options)?.optionName) ||
      (ele?.type === "Dropdown" && ele.isDeciding) ||
      (ele?.type === "File" && decideChild?.response?.optionId === ele?.refOptionId && ele?.response?.files?.some(file => !isEmptyDash(file?.key)))
    );
  };
  const decideChild = props?.data?.child.find(child => child?.isDeciding);
  return (

    <div className="" >
      {props?.data?.type == "File" && (
        <>
          <div className="images_react_app" style={{ display: "inline-block" }}>
            {/* {!isEmptyDash(props?.data?.response?.files[0]?.key) && ( */}
            {/* {props?.data?.response?.files && props.data.response.files.length > 0 && (
              <div
                className="vendor_maine_content " 
                onClick={() => viewMMedia(props?.data?.response?.files[0]?.key, props?.data?.response?.files[0]?.name)}
              > 
                <img src={pdfImage} alt="" />{" "}
                {formatFileName(props?.data?.response?.files[0]?.name)} 
              </div>
            )} */}
            {props?.data?.response?.files && props.data.response.files.length > 0 ? (
              <>
                {props.data.response.files.map((file, index) => (
                  <div
                    key={index}
                    className="vendor_maine_content "
                    onClick={() => viewMMedia(file?.key, file?.name)}
                    style={{ marginBottom: "10px" }}
                  >
                    <img src={pdfImage} alt="" />
                    <Tooltip title={file?.name}>   {!isEmptyDash(file?.name) ? formatFileName(file?.name) : 'N/A'}</Tooltip>
                  </div>
                ))}
              </>
            ) : (
              <div className="">
                N/A
              </div>
            )}
          </div>
        </>
      )
      }

      {
        props?.data?.type == "String" && (
          <>
            <div>{(props?.data?.response?.answer ? props?.data?.response?.answer : 'N/A')}</div>
          </>
        )
      }

      {
        props?.data?.type == "Dropdown" && (
          <>
            <div>
              {
                getAnsFromOptId(props?.data?.response, props?.data?.options)?.optionName ?? "N/A"
              }
              {/* {props?.data?.response?.answer} */}
            </div>
          </>
        )
      }
      
      {
        props?.data?.type == "MultiSelect" && (
          <>
            <div>
              {
                getAnsFromOptIds(props?.data?.response, props?.data?.options) ?? "N/A"
              }
              {/* {props?.data?.response?.answer} */}
            </div>
          </>
        )
      }



      {
        props?.data?.type == "MultiField" &&
        props?.data?._id != "65dda2f43e446a7c0e67c9eb" && (
          <>
            <div className="">
              {props?.data?.child?.map((ele, i) => (
                <>
                  {i !== 0 && shouldDisplayChildDetailsGap(ele, decideChild, getAnsFromOptId, isEmptyDash) && i < props?.data?.child.length && (
                    <div className="child-details-gap" style={displayStyle()}>|</div>
                  )}

                  {ele.isDeciding === true && _.isEmpty(ele.response) && (
                    <div className="child-details-gap" style={displayStyle()}>N/A</div>
                  )}

                  {/* {ele.isDeciding === true && !isEmptyDash(ele?.response?.optionIds) && (
                    <div className="child-details-gap" style={displayStyle()}>N/A</div>
                  )} */}

                  {ele?.type == "String" && (
                    <>
                      <div className="child-details-gap" style={displayStyle()}>
                        {/* {(ele?.response?.childAnswer) ? ele?.response?.childAnswer : 'N/A'} */}
                      <Tooltip title={(ele?.response?.childAnswer) || "N/A"}>
                      {(ele?.response?.childAnswer) ? trimString((ele?.response?.childAnswer), 20) : "N/A"}
                      </Tooltip>
                      </div>
                    </>
                  )}
                  {ele?.type == "String" && (decideChild && decideChild?.response?.optionId === ele?.refOptionId) && (
                    <>
                      <div className="child-details-gap" style={displayStyle()}>
                        {/* {(!isEmptyDash(ele?.response?.childAnswer)) ? ele?.response?.childAnswer : 'N/A'} */}                        
                        <Tooltip title={(!isEmptyDash(ele?.response?.childAnswer)) || "N/A"}>
                                  {(!isEmptyDash(ele?.response?.childAnswer)) ? trimString((!isEmptyDash(ele?.response?.childAnswer)), 20) : "N/A"}
                                 </Tooltip>
                      </div>
                    </>
                  )}

                  {ele?.type == "Dropdown" && ele.isDeciding === true && (
                    <div className="child-details-gap" style={displayStyle()}>
                      {getAnsFromOptId(ele?.response, ele?.options)?.optionName}
                    </div>
                  )}

                  {ele?.type == "Dropdown" && decideChild?.response?.optionId === ele?.refOptionId && (
                    <>
                      <div className="child-details-gap" style={displayStyle()}>
                        {
                          getAnsFromOptId(ele?.response, ele?.options)?.optionName
                        }
                        {/* {ele?.response?.answer} */}
                      </div>
                    </>
                  )}
                  {/* 
                  {ele?.type == "File" && (
                    <>
                      <div classNayme="child-details-gap images_react_app" style={{ marginTop: '5px', display: 'inline-block' }}>
                        {(!_.isEmpty(ele?.response)) && <>
                          {!isEmptyDash(ele?.response?.files[0]?.key) && (
                            <div
                              className="vendor_maine_content "
                              //onClick={() => props.viewMedia(ele?.response?.childAnswer)}
                              onClick={() =>
                                viewMMedia(ele?.response?.files[0]?.key, ele?.response?.files[0]?.name)
                              }
                            > 
                              <img src={pdfImage} alt="" /> 
                              {formatFileName(getFileNameByPath(ele?.response?.files[0]?.key))} 
                            </div>
                          )}
                        </>} 
                      </div>
                    </>
                  )} */}

                  {ele?.type == "File" && (decideChild && decideChild?.response?.optionId === ele?.refOptionId) && (
                    <div className="child-details-gap images_react_app" style={{ marginTop: '5px', display: 'inline-block' }}>
                      {(!_.isEmpty(ele?.response)) && ele?.response?.files.map((file, index) => (
                        !isEmptyDash(file?.key) && (
                          <div
                            key={index}
                            className="vendor_maine_content"
                            onClick={() => viewMMedia(file?.key, file?.name)}
                            style={{ marginBottom: '3px' }}
                          >
                            <img src={pdfImage} alt="" />
                            <Tooltip title={file?.name} > {!isEmptyDash(file?.name) ? formatFileName(file?.name) : 'N/A'}</Tooltip>
                            {/* {formatFileName(getFileNameByPath(file?.key))} */}
                          </div>
                        )
                      ))}
                    </div >
                  )}

                </>
              ))}
            </div>
          </>
        )
      }

      <FileViewerModal
        fileSrc={fileSrc}
        isOpen={isModalOpen}
        onClose={closeModal}
        fileExtension={fileExtension}
        isSubmitCondition={false}
        fileName={fileName}
      />

      {
        props?.data?.type == "MultiField" &&
        props?.data?._id == "65dda2f43e446a7c0e67c9eb" && (
          <>
            <div className="">
              {props?.data?.child.map((ele, i) => (
                <>
                  {ele?.type == "Object" && (
                    <>
                      <div className="child-details-gap">
                        {getObjectAns(ele?.response?.childAnswer) ? `${i + 1}. ${getObjectAns(ele.response.childAnswer)}` : 'N/A'}
                      </div>
                    </>
                  )}
                  {/* {(i < props?.data?.child.length -1) && <div className="child-details-gap">|</div>} */}
                </>
              ))}
            </div>
          </>
        )
      }




    </div >
  );
}

export default GetDetailsAns;
